import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Divider,
  Paper,
  IconButton,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Print as PrintIcon,
  Map as MapIcon,
  Add as AddIcon,
  Bookmark as BookmarkIcon,
  LocationOn as LocationOnIcon,
  ExpandLess,
  ExpandMore,
  AdsClick as AdsClickIcon,
} from "@mui/icons-material";
import PinDropIcon from "@mui/icons-material/PinDrop";

/** print tool drawer panel */
export default function PrintToolPanel(ctx) {
  const {
    printTemplate,
    setPrintTemplate,
    printPage,
    setPrintPage,
    printFormat,
    setPrintFormat,
    printTitle,
    setPrintTitle,
    printCreatedBy,
    setPrintCreatedBy,
    printGenerating,
    handlePrintPreview,
    onCloseTool,
  } = ctx;

  return (
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
                  >
                    Print Map
                  </Typography>

                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Print Template
                    </Typography>
                    <Select
                      fullWidth
                      size="small"
                      value={printTemplate}
                      onChange={(e) => setPrintTemplate(e.target.value)}
                      sx={{ bgcolor: "white" }}
                    >
                      <MenuItem value="landscape">Landscape</MenuItem>
                      <MenuItem value="portrait">Portrait</MenuItem>
                    </Select>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Page Size
                    </Typography>
                    <Select
                      fullWidth
                      size="small"
                      value={printPage}
                      onChange={(e) => setPrintPage(e.target.value)}
                      sx={{ bgcolor: "white" }}
                    >
                      <MenuItem value="A4">A4 (210 x 297 mm)</MenuItem>
                      <MenuItem value="A3">A3 (297 x 420 mm)</MenuItem>
                      <MenuItem value="A2">A2 (420 x 594 mm)</MenuItem>
                      <MenuItem value="A1">A1 (594 x 841 mm)</MenuItem>
                      <MenuItem value="A0">A0 (841 x 1189 mm)</MenuItem>
                    </Select>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Output Format
                    </Typography>
                    <Select
                      fullWidth
                      size="small"
                      value={printFormat}
                      onChange={(e) => setPrintFormat(e.target.value)}
                      sx={{ bgcolor: "white" }}
                    >
                      <MenuItem value="PNG">PNG Image</MenuItem>
                      <MenuItem value="JPEG">JPEG Image</MenuItem>
                      <MenuItem value="PDF">PDF Document</MenuItem>
                    </Select>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Title
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Enter map title"
                      value={printTitle}
                      onChange={(e) => setPrintTitle(e.target.value)}
                      sx={{ bgcolor: "white" }}
                    />
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Created By
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Enter your name"
                      value={printCreatedBy}
                      onChange={(e) => setPrintCreatedBy(e.target.value)}
                      sx={{ bgcolor: "white" }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      mt: "auto",
                      flexShrink: 0,
                      mb: 2,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<PrintIcon />}
                      onClick={handlePrintPreview}
                      disabled={printGenerating}
                      sx={{
                        bgcolor: "#1976d2",
                        "&:hover": { bgcolor: "#115293" },
                      }}
                    >
                      {printGenerating ? "Generating..." : "Print Preview"}
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      onClick={() => {
                        onCloseTool("print");
                      }}
                      sx={{ borderColor: "#f44336", color: "#f44336" }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
  );
}
